export default {
  dueDiligenceExemptions: [],
  loading: false
}
